import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
// import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { loadGapiInsideDOM } from 'gapi-script';

import { SocialAuthService, FacebookLoginProvider } from '@abacritt/angularx-social-login';


import { parsePhoneNumberFromString } from 'libphonenumber-js';

declare var gapi: any;

// Tambahkan deklarasi untuk intlTelInput dengan tipe yang lebih spesifik
declare var intlTelInput: {
  (element: HTMLElement, options?: {
    initialCountry?: string;
    separateDialCode?: boolean;
    utilsScript?: string;
    // Tambahkan opsi lain sesuai kebutuhan
  }): any;
};

@Component({
  selector: 'app-login-wa',
  templateUrl: './login-wa.component.html',
  styleUrls: ['./login-wa.component.css']
})
export class LoginWaComponent implements OnInit {
  @ViewChild('phoneInput') phoneInput!: ElementRef;
  @ViewChild('recaptcha', { static: false }) recaptchaElement!: ElementRef;

  
  
  isLoading: boolean = false;
  isImageError = false;
  errorMessage: string = '';

  phoneForm!: FormGroup;
  otpForm!: FormGroup;
  registerForm!: FormGroup;



  step: 'phone' | 'otp' | 'register' | 'existing' = 'phone';
  submitted = false;

  // Tambahkan variabel untuk menyimpan instance intlTelInput
  private intlTelInputInstance: any;

  // Timer untuk OTP
  remainingTime = 180; // 3 menit (dalam detik)
  private countdownInterval: any;


  recaptchaSiteKey: string = environment.recaptchaSiteKey;
  recaptchaVerified: boolean = false;
  submittedreg = false;

   constructor(
    private fb: FormBuilder, 
    private router: Router,
    private authService: AuthService,
    private socialAuthService: SocialAuthService
    ) {
      this.initializeForms();
    }

    private initializeForms() {
      this.phoneForm = this.fb.group({
        phone: ['', [
          Validators.required, 
          Validators.pattern('^[0-9]{10,13}$') // Ensure that phone number is valid
        ]]
      });

      this.otpForm = this.fb.group({
        otp: ['', [
          Validators.required,
          Validators.pattern('^[0-9]{6}$') // Validasi OTP 6 digit
        ]]
      });
  
      // Add registration form
      this.registerForm = this.fb.group({
        name: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        recaptcha: ['', Validators.required]
      });
    }



  



    user: { name: string, email: string, photo: string, user_login: string, user_wa: string } | null = null;
    showLoginForm: boolean = true; // Menampilkan atau menyembunyikan form login


  ngOnInit(): void {

    this.loadIntlTelInputScript();

    setTimeout(() => {
      this.initializePhoneInput();
    }, 50);


    const userName = localStorage.getItem('user_name');
    const userEmail = localStorage.getItem('user_email');
    const userPhoto = localStorage.getItem('user_photo');
    const userLogin = localStorage.getItem('user_login');
    const userWa = localStorage.getItem('user_wa');


    // console.log( userName +" "+ userEmail +" "+userPhoto +" "+userLogin+" "+userWa);

    // Cek jika data pengguna ada
    if (userName && userEmail && userLogin) {
      this.user = { name: userName, email: userEmail, photo: userPhoto || '', user_login: userLogin, user_wa: userWa ||'' };
      this.showLoginForm = false; // Sembunyikan form login

      if (userWa) {
      const phoneNumber = parsePhoneNumberFromString(userWa);
        if (phoneNumber){
          this.phoneForm.patchValue({    
            phone: phoneNumber.nationalNumber
          });
         
          // console.log(phoneNumber.nationalNumber);
        }    
      }
   

      if (userLogin != 'whatsapp')
      {
        this.router.navigate(['/login-pelanggan']);
      }
    
    } else {
      this.router.navigate(['/login-pelanggan/whatsapp']); // Redirect ke halaman login jika data tidak ada
      this.showLoginForm = true;
    }


    const token = localStorage.getItem('authToken');
    if (token) {
      this.router.navigate(['/home']); // Redirect jika token ada
    }

    // Pastikan library intlTelInput sudah dimuat
 

    this.loadGoogleScript();
  }


      // Fungsi untuk memuat script intlTelInput secara dinamis
      private loadIntlTelInputScript() {
        if (!(window as any).intlTelInput) {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js';
          script.onload = () => {
            const utilsScript = document.createElement('script');
            utilsScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js';
            document.head.appendChild(utilsScript);
          };
          document.head.appendChild(script);
        }
      }
    
      // Fungsi untuk inisialisasi input telepon
      private initializePhoneInput() {
        if (this.phoneInput && (window as any).intlTelInput) {
          const input = this.phoneInput.nativeElement;
          
          // Hapus instance sebelumnya jika ada
          if (this.intlTelInputInstance) {
            this.intlTelInputInstance.destroy();
          }
    
          // Inisialisasi intlTelInput dengan opsi yang lebih lengkap
          this.intlTelInputInstance = intlTelInput(input, {
            initialCountry: 'id', 
            separateDialCode: true, 
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js'
          });
        }
      }
  

   // Optional: Programmatic sign-in trigger
      private loadGoogleScript() {
        loadGapiInsideDOM().then(() => {
          gapi.load('auth2', () => {
            gapi.auth2.init({
              client_id: environment.googleClientId,
              cookiepolicy: 'single_host_origin',
            });
          });
        });
       }  

  handleGoogleLogin() {
      const auth2 = gapi.auth2.getAuthInstance();
      auth2.signIn({
        prompt: 'consent',
        scope: 'openid email profile'
      }) // Memunculkan dialog untuk memilih akun
        .then((googleUser: any) => {
          // Memeriksa jika login berhasil
          if (googleUser) {
            // const profile = googleUser.getBasicProfile();
            const idToken = googleUser.getAuthResponse().id_token;
            // Jika perlu, bisa mengirim data ke server untuk proses login
            this.authService.loginWithGoogle(idToken).subscribe(
              (res) => {
  
                const dt = res.user;
                  // Simpan data ke localStorage
                  localStorage.setItem('authToken', idToken);  // Token untuk autentikasi
                  localStorage.setItem('user_name', dt.nama);
                  localStorage.setItem('user_email', dt.email);
                  localStorage.setItem('user_photo', dt.foto);
                  localStorage.setItem('user_login', 'google');
          
                  // Menyimpan objek data pengguna untuk penggunaan lainnya
                  localStorage.setItem('user_pelanggan', JSON.stringify({
                    name: dt.nama,
                    email: dt.emai,
                    photo: dt.foto
                  }));
  
                // Redirect ke halaman utama setelah login sukses
                 window.location.href = '/home';
              },
              (error) => {
                this.errorMessage = 'Failed to login with Google. Please try again.';
              }
            );
          } else {
            this.errorMessage = 'Google login was cancelled or failed. Please try again.';
          }
        })
        .catch((error: any) => {
          // Menangani jika pengguna membatalkan login atau terjadi kesalahan lainnya
          this.errorMessage = 'Google login was cancelled or failed. Please try again.';
        });
    }
  
    // =====================
    // Facebook Login
    // =====================
    loginWithFacebook(): void {
      this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID)
        .then(fbUser => {   
        // Kirim token Facebook ke backend untuk divalidasi
        this.authService.loginWithFacebook(fbUser.authToken).subscribe({
          next: (res) => {
            const dt = res.user;
            // Simpan data ke localStorage
            localStorage.setItem('authToken', fbUser.authToken);  // Token untuk autentikasi
            localStorage.setItem('user_name', dt.nama);
            localStorage.setItem('user_email', dt.email);
            localStorage.setItem('user_photo', dt.foto);
            localStorage.setItem('user_login', 'facebook');
    
            // Menyimpan objek data pengguna untuk penggunaan lainnya
            localStorage.setItem('user_pelanggan', JSON.stringify({
              name: dt.nama,
              email: dt.emai,
              photo: dt.foto
            }));
    
          // Redirect ke halaman utama setelah login sukses
            window.location.href = '/home';
  
          },
          error: (err) => {
            console.error('Error login:', err);
          }
        });
      })
      .catch(err => {
        console.error('Error saat login Facebook:', err);
      });
  
    }




  handleImageError(event: Event) {
    this.isImageError = true;
    (event.target as HTMLImageElement).style.display = 'none'; // Sembunyikan elemen gambar jika gagal
  }

    // Fungsi untuk menampilkan email yang dimasking
    getMaskedEmail(email: string): string {
      if (!email) return '';
      const [localPart, domain] = email.split('@');
      const maskedLocalPart = localPart.substring(0, 2) + '******'; // Masking 2 huruf pertama
      return `${maskedLocalPart}@${domain}`;
    }
    
    getMaskedPhone(phone: string): string {
      if (!phone) return '';
      
      const phoneLength = phone.length;
      
      // Pastikan nomor telepon memiliki lebih dari 3 digit
      if (phoneLength <= 3) return phone;  // Jika nomor telepon kurang dari atau sama dengan 3 karakter, tidak ada masking
      
      // Mengambil 3 digit terakhir dan mem-masking sisanya dengan "*"
      const maskedPhone = '*'.repeat(phoneLength - 3) + phone.slice(-3);
  
      return maskedPhone;
  }
  

  logout2(event: Event): void {
    event.preventDefault();
  
  
    // Menghapus data sesi
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_photo');
    localStorage.removeItem('user_login');
    localStorage.removeItem('user_wa');
    window.location.reload();
  }

 // Safely get form control with null check
 getFormControl(form: FormGroup, controlName: string): AbstractControl | null {
  return form.get(controlName);
}


// Safely check if control has specific error
hasError(form: FormGroup, controlName: string, errorType: string): boolean {
  const control = this.getFormControl(form, controlName);
  return control ? (this.submitted && control.hasError(errorType)) : false;
}

switchToEmailLogin() {
  this.router.navigate(['/login-pelanggan']);
}



onContinueWithPhone() {
  this.submitted = true;
  const phoneControl = this.getFormControl(this.phoneForm, 'phone');
  
  if (phoneControl && this.phoneForm.valid) {
    this.onSendOtp();
  }
}



lanjut(){
  this.submitted = true;
  const phoneControl = this.getFormControl(this.phoneForm, 'phone');
  
  if (phoneControl && this.phoneForm.valid) {
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_photo');
    localStorage.removeItem('user_login');
    localStorage.removeItem('user_wa');
    this.showLoginForm = true
    this.onSendOtp();
  }
}


// Kirim OTP ke WhatsApp
onSendOtp(): void {
  this.submitted = true;

  if (this.phoneForm.invalid) {
    return;
  }

   // Ambil data negara yang dipilih
   const countryData = this.intlTelInputInstance.getSelectedCountryData();
   const dialCode = countryData.dialCode; // Kode negara (misalnya "+62")

  const phoneNumber = this.phoneForm.value.phone;

   // Gabungkan kode negara dengan nomor telepon
   const fullPhoneNumber = `+${dialCode}${phoneNumber.replace(/\D/g, "")}`;

  
  this.isLoading = true;
  this.authService.sendOtp(fullPhoneNumber).subscribe({
    next: () => {
      this.isLoading = false;
      this.submitted = false;
      this.step = 'otp'; // Pindah ke langkah OTP
      this.startCountdown(); // Mulai hitung mundur
    },
    error: (err) => {
      this.isLoading = false;
      this.errorMessage = 'Failed to send OTP. Please try again.';
      console.error(err);
    }
  });
}


// Request OTP ulang
onRequestOtpAgain(): void {
  this.remainingTime = 300; // Reset waktu 5 menit
  this.onSendOtp(); // Kirim OTP lagi
}

// Fungsi untuk memulai hitung mundur
private startCountdown(): void {
  this.remainingTime = 300; // 5 menit
  clearInterval(this.countdownInterval); // Hentikan interval sebelumnya jika ada

  this.countdownInterval = setInterval(() => {
    if (this.remainingTime > 0) {
      this.remainingTime--;6
    } else {
      clearInterval(this.countdownInterval);
    }
  }, 1000); // Interval setiap detik
}

// Fungsi untuk format waktu (MM:SS)
formatTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}


// Verifikasi OTP
onVerifyOtp(): void {
  this.submitted = true;

  if (this.otpForm.invalid) {
    return;
  }

  const otpCode = this.otpForm.value.otp;
  // Ambil data negara yang dipilih
  const countryData = this.intlTelInputInstance.getSelectedCountryData();
  const dialCode = countryData.dialCode; // Kode negara (misalnya "+62")

 const phoneNumber = this.phoneForm.value.phone;

  // Gabungkan kode negara dengan nomor telepon
 const fullPhoneNumber = `+${dialCode}${phoneNumber.replace(/\D/g, "")}`;

  this.isLoading = true;
  this.authService.verifyOtp(fullPhoneNumber, otpCode).subscribe({
    next: (res) => {
     
        // Cek kondisi registrasi berdasarkan status pengguna
        if (
          !res.user || // Belum terdaftar 
          res.user.nama === 'WhatsApp User' // Terdaftar tapi nama masih default
        ) {

          this.submitted = false;
          // Pindah ke halaman registrasi
          this.step = 'register';
          
          // Isi form registrasi dengan data yang tersedia
          this.registerForm.patchValue({
            phoneNumber: fullPhoneNumber,
            countryName: countryData.name,
            authToken : res.token
          });
          this.isLoading = false;

        } else {
          // Pengguna sudah terdaftar lengkap, lakukan login langsung
          const dt = res.user;
          
          // Simpan data ke localStorage
          localStorage.setItem('authToken', res.token);
          localStorage.setItem('user_name', dt.nama);
          localStorage.setItem('user_email', dt.email);
          localStorage.setItem('user_photo', dt.foto || '');
          localStorage.setItem('user_wa', dt.whatsapp_number);
          localStorage.setItem('user_login', 'whatsapp');
          
          // Menyimpan objek data pengguna untuk penggunaan lainnya
          localStorage.setItem('user_pelanggan', JSON.stringify({
            name: dt.nama,
            email: dt.email,
            photo: dt.foto
          }));
          this.isLoading = false;
          // Redirect ke halaman utama
          window.location.href = '/home';

        }

    },
    error: (err) => {
      this.isLoading = false;
      this.errorMessage = 'Invalid OTP or OTP has expired!';
      console.error(err);
    }
  });
}

// New method to complete registration
onCompleteRegistration() {
  this.submitted = true;
 
     // Verify reCAPTCHA
     const recaptchaResponse = (window as any).grecaptcha.getResponse();
     this.recaptchaVerified = recaptchaResponse.length > 0;
 
     if (this.registerForm.valid && this.recaptchaVerified) {
       this.isLoading = true;
 
       const countryData = this.intlTelInputInstance.getSelectedCountryData();
       const dialCode = countryData.dialCode; // Kode negara (misalnya "+62")
     
       const phoneNumber = this.phoneForm.value.phone;
     
       // Gabungkan kode negara dengan nomor telepon
       const fullPhoneNumber = `+${dialCode}${phoneNumber.replace(/\D/g, "")}`;
  
     
        // Panggil fungsi registerWithWhatsApp
        this.authService.registerWithWhatsApp(fullPhoneNumber,this.registerForm.value.email,this.registerForm.value.name).subscribe(
         (response: any) => {
           this.isLoading = false;
            
            if (response.status === 'existing') {
              // Jika email sudah terdaftar, redirect ke login sesuai metode login
              this.user = response.user;
              const loginMethod = response.user.login_method;
              const dt = response.user;
              console.log(dt);

              const userName = dt.name;
              const userEmail = dt.email;
              const userPhoto = dt.photo || '';
              const userLogin = dt.login_method;
              const userWa = dt.whatsapp_number;
          
              // Cek jika data pengguna ada
              if (userName && userEmail && userPhoto && userLogin && userWa) {
                this.user = { name: userName, email: userEmail, photo: userPhoto, user_login: userLogin, user_wa: userWa };
                this.showLoginForm = false; // Sembunyikan form login
              }

              this.submitted = false;
              this.step = 'existing';
            } else if (response.status === 'new') {
              // Jika pengguna baru, lanjutkan proses login WhatsApp
                // alert('Registrasi berhasil. Lanjutkan login dengan OTP WhatsApp.');
          
                const dt = response.user;
            
                // Simpan data ke localStorage
                localStorage.setItem('authToken', response.token);
                localStorage.setItem('user_name', dt.nama);
                localStorage.setItem('user_email', dt.email);
                localStorage.setItem('user_photo', dt.foto || '');
                localStorage.setItem('user_wa', dt.whatsapp_number);
                localStorage.setItem('user_login', 'whatsapp');
                
                // Menyimpan objek data pengguna untuk penggunaan lainnya
                localStorage.setItem('user_pelanggan', JSON.stringify({
                  name: dt.nama,
                  email: dt.email,
                  photo: dt.foto
                }));
                // Dapatkan rute asal
                  const redirectUrl = this.authService.getRedirectUrl() || '/home'; // Default ke /dashboard jika tidak ada rute asal
                  window.location.href = redirectUrl;
                  this.submitted = false;
            }
         
         },
         (error) => {
           this.isLoading = false;
           console.error(error);
         });
    
     }
 } 
 



}
